var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem43(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st1{fill:#fff}\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179 128c-18.2.1-33.9 7.1-47.3 21-23.6 31.3-22.2 61.3 4.2 90.1 12.8 11.2 27.1 16.7 43 16.7 18.2-.1 34-7.1 47.4-21.1 23.4-31.3 22-61.3-4.4-90.1-12.8-11.1-27.1-16.6-42.9-16.6z",
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.5 191.8c0-18.4-7-34.3-21-47.9-13-11.2-27.5-16.7-43.5-16.6-18.4 0-34.3 7-47.9 21-11.2 13-16.8 27.5-16.8 43.5.1 18.4 7.1 34.3 21.2 47.9 12.9 11.2 27.4 16.8 43.5 16.8 18.4-.1 34.3-7.1 47.9-21.2 11.1-12.9 16.7-27.4 16.6-43.5m-22-46.9c13.7 13.4 20.6 29 20.6 46.9 0 15.8-5.5 29.9-16.4 42.5-13.2 13.9-28.7 20.8-46.7 20.8-15.8.1-29.9-5.4-42.5-16.4-13.8-13.3-20.8-28.9-20.8-46.9 0-15.6 5.5-29.8 16.4-42.5 13.2-13.8 28.8-20.6 46.9-20.6 15.6 0 29.8 5.4 42.5 16.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 138.2385,
    x2: 166.8996,
    y1: 170.6675,
    y2: 237.8934,
    gradientTransform: "matrix(1.3158 0 0 -1.3157 -21.7899 460.7795)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#505050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    style: {
      stopColor: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#505050"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.3 156.4c-9.6-8.3-20.3-12.4-32.2-12.4-13.7.1-25.6 5.3-35.7 15.8-17.7 23.5-16.6 46.2 3.4 68 9.5 8.3 20.2 12.4 32 12.4 13.7 0 25.7-5.3 35.9-15.8 17.6-23.7 16.4-46.3-3.4-68z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.6 191.9c0-13.8-5.3-25.8-16-36.1-9.7-8.4-20.6-12.6-32.7-12.6-13.8.1-25.8 5.4-36.1 16-8.5 9.7-12.8 20.6-12.8 32.7.1 13.8 5.4 25.8 16 36.1 9.7 8.6 20.7 12.9 32.9 12.8 13.8 0 25.8-5.3 36.1-16 8.4-9.8 12.6-20.8 12.6-32.9m-1.4 0c.1 11.8-4 22.4-12.2 31.9-9.9 10.3-21.6 15.5-35.1 15.6-11.8 0-22.4-4.1-31.9-12.4-10.3-9.9-15.5-21.6-15.6-35.1.1-11.7 4.2-22.3 12.4-31.9 9.9-10.3 21.6-15.4 35.1-15.4 11.8 0 22.4 4.1 31.9 12.2 10.1 10 15.3 21.7 15.4 35.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5 175.6c-4.3-3.7-9.1-5.6-14.5-5.6-6.3 0-11.7 2.4-16.3 7.2-7.9 10.6-7.4 20.9 1.6 30.9 4.3 3.7 9.1 5.6 14.5 5.6 6.3 0 11.7-2.4 16.3-7.2 8-10.6 7.5-20.9-1.6-30.9z",
    className: "st1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.6 174.6c-4.6-4-9.8-6-15.6-6-6.7 0-12.4 2.5-17.2 7.6-4 4.6-6 9.8-6 15.6 0 6.7 2.5 12.4 7.6 17.2 4.6 4 9.8 6 15.6 6 6.5 0 12.3-2.5 17.2-7.6 4-4.6 6-9.8 6-15.6-.1-6.5-2.6-12.2-7.6-17.2m-15.7-3.2c5.1 0 9.6 1.8 13.6 5.4 4.5 4.2 6.8 9.2 6.8 15 0 5.1-1.8 9.7-5.4 13.8-4.2 4.4-9.2 6.6-15 6.6-5.1 0-9.7-1.7-13.8-5.2-4.4-4.3-6.6-9.3-6.6-15.2 0-5 1.7-9.5 5.2-13.6 4.3-4.5 9.4-6.8 15.2-6.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M189.6 180.3c-3.1-2.8-6.7-4.2-10.6-4.2-4.5 0-8.5 1.7-11.8 5.2-5.8 7.7-5.4 15.2 1.2 22.4 3.1 2.7 6.6 4 10.5 4 4.5 0 8.4-1.7 11.7-5.2 5.9-7.7 5.5-15.1-1-22.2z",
    className: "st1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.4 191.9c0-4.7-1.8-8.7-5.4-12.2-3.2-2.8-6.9-4.2-11-4.2-4.8 0-8.9 1.8-12.2 5.4-2.9 3.1-4.4 6.8-4.4 11 0 4.7 1.8 8.8 5.4 12.2 3.3 2.9 7.1 4.4 11.2 4.4 4.7 0 8.7-1.8 12.2-5.4 2.8-3.3 4.2-7 4.2-11.2m-6.2-11.2c3.2 3.2 4.8 6.9 4.8 11.2.1 3.7-1.2 7.1-3.8 10.2-3.3 3.3-7 4.9-11.2 5-3.7-.1-7.1-1.4-10.2-4-3.3-3.1-4.9-6.9-5-11.2.1-3.7 1.4-7.1 4-10.2 3.1-3.2 6.9-4.8 11.2-4.8 3.7-.1 7.1 1.2 10.2 3.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 457.5714,
    x2: 427.8964,
    y1: 255.5613,
    y2: 321.1613,
    gradientTransform: "matrix(1.3158 0 0 -1.3157 -21.7899 460.7795)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#505050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    style: {
      stopColor: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#505050"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M560.6 33.5c-4.7 0-9.4.7-14.1 2.1-27.1 11.2-37.6 31.2-31.4 60.1 8.2 21.5 23.4 32.7 45.7 33.7 4.8 0 9.5-.7 14.3-2.2 27.1-11.2 37.7-31.2 31.6-59.9-8.5-21.6-23.8-32.8-46.1-33.8z",
    style: {
      fill: "url(#SVGID_2_)"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M609.4 81.6c0-4.8-.7-9.6-2.2-14.4-8.3-21.8-23.8-33.3-46.5-34.3-4.8-.1-9.6.7-14.4 2.2-21.8 8.3-33.3 23.8-34.3 46.5.1 4.7.8 9.5 2.2 14.4 8.3 21.8 23.8 33.3 46.5 34.3 4.8-.1 9.6-.8 14.4-2.2 21.9-8.5 33.3-24 34.3-46.5m-3.6-14c1.5 4.7 2.2 9.3 2.2 14-.9 21.9-12 36.9-33.3 45.1-4.7 1.4-9.3 2.1-14 2.2-22-1-37.1-12.1-45.1-33.3-1.4-4.8-2.1-9.5-2.2-14 1-22 12.1-37.1 33.3-45.1 4.7-1.5 9.3-2.3 14-2.2 22.1.9 37.1 12 45.1 33.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M576.4 76.6c-2.7-7.3-7.9-11.1-15.4-11.4-1.7 0-3.3.3-5 .8-9.2 3.8-12.8 10.6-10.8 20.4 2.8 7.3 8 11.2 15.6 11.5 1.6 0 3.2-.2 4.8-.7 9.3-3.8 12.9-10.7 10.8-20.6z",
    className: "st1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M577.9 81.4c0-1.7-.3-3.5-.8-5.2-2.9-7.6-8.3-11.6-16.2-12-1.7.1-3.3.3-5 .8-7.7 2.9-11.8 8.4-12 16.4-.1 1.7.2 3.3.8 5 2.9 7.7 8.3 11.8 16.2 12 1.7.1 3.3-.2 5-.8 7.6-2.8 11.6-8.2 12-16.2m-2-4.6c.4 1.5.6 3 .6 4.6-.3 7.2-3.9 12.2-11 15-1.5.4-3.1.6-4.6.6-7.2-.3-12.2-3.9-15-11-.4-1.6-.6-3.1-.6-4.6.3-7.4 3.9-12.4 11-15 1.5-.5 3.1-.7 4.6-.8 7.1.3 12.1 4.1 15 11.2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M572.2 78c-2.1-5.3-5.9-8.1-11.4-8.4-1.2 0-2.4.2-3.6.6-6.6 2.8-9.2 7.7-7.8 14.8 2 5.3 5.8 8.1 11.3 8.3 1.2 0 2.4-.2 3.7-.5 6.6-2.8 9.2-7.7 7.8-14.8z",
    className: "st1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M573.9 81.5c0-1.3-.2-2.7-.6-4-2.2-5.9-6.4-9.1-12.6-9.4-1.3 0-2.6.2-4 .6-5.9 2.3-8.9 6.5-9.2 12.8 0 1.3.2 2.5.6 3.8 2.3 6.1 6.5 9.2 12.6 9.4 1.3 0 2.7-.2 4-.6 5.9-2.2 8.9-6.4 9.2-12.6m-3.2-3.2c.3 1.1.5 2.1.4 3.2-.2 4.9-2.6 8.2-7.2 10-1.1.3-2.2.4-3.2.4-4.8-.1-8.1-2.6-10-7.4-.3-1-.5-2-.4-3 .2-4.9 2.7-8.3 7.4-10 1-.4 2-.6 3-.6 4.8.3 8.2 2.7 10 7.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M586 107.4c-2.9-7.3-8.1-11.2-15.8-11.5-1.6 0-3.2.2-4.8.7-5.9 2.2-9.5 6.2-11 12L226.8 210.9c-3.1-2.8-6.7-4.2-11-4.3-1.7 0-3.3.2-4.8.7-9.4 3.8-13 10.6-10.8 20.4 2.7 7.4 7.9 11.3 15.4 11.6 1.7 0 3.3-.3 5-.8 5.9-2.1 9.7-6.1 11.2-12l327.3-102.4c3.1 2.9 6.8 4.3 11 4.4 1.7 0 3.3-.3 5-.8 9.3-3.7 12.9-10.5 10.9-20.3z",
    className: "st1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M587.4 112.1c0-1.5-.3-3.2-.8-5-2.9-7.6-8.3-11.6-16.2-12-1.7-.1-3.5.2-5.2.8-6.1 2.2-9.8 6.2-11.3 12.1L227 210.2c-3.3-2.9-7-4.3-11.2-4.3-1.8 0-3.5.3-5 .8-7.8 2.9-11.9 8.3-12.2 16.2.1 1.7.3 3.3.8 5 2.9 7.7 8.4 11.7 16.4 12 1.7 0 3.3-.2 5-.6 6-2.2 9.8-6.2 11.5-12.1L559.1 125c3.1 2.7 6.9 4.2 11.3 4.3 1.7-.1 3.3-.3 5-.8 7.8-2.9 11.8-8.4 12-16.4m-2.2-4.6c.6 1.7.9 3.2.8 4.6-.4 7.4-4.1 12.4-11 15-1.6.6-3.1.9-4.6.8-4.1-.1-7.7-1.5-10.6-4.2l-.4-.4-.4.2-327.5 102.4h-.2l-.2.4c-1.3 5.7-4.9 9.5-10.6 11.6-1.7.4-3.2.6-4.6.6-7.4-.3-12.4-3.9-15-11-.5-1.4-.7-2.9-.8-4.6.3-7.2 4.1-12.2 11.2-15 1.4-.4 2.9-.6 4.6-.6 4.1 0 7.7 1.4 10.6 4.2l.2.2.4-.2 327.5-102.2.4-.2v-.4c1.4-5.6 4.9-9.4 10.6-11.4 1.6-.5 3.2-.8 4.8-.8 7.2.4 12.2 4.1 14.8 11z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M578.1 109.8c-1.5-3.6-4.1-5.5-8-5.7-.7 0-1.5.1-2.2.3-4.7 2-6.5 5.4-5.4 10.2 1.3 3.7 3.8 5.7 7.7 5.8.8 0 1.6-.1 2.5-.4 4.6-1.8 6.4-5.2 5.4-10.2zM223.7 220.6c-1.5-3.7-4-5.7-7.7-5.8-.9 0-1.7.1-2.5.4-4.7 2-6.5 5.4-5.4 10.2 1.3 3.7 3.8 5.7 7.7 5.8.8 0 1.6-.1 2.5-.4 4.6-2 6.4-5.4 5.4-10.2zM635.7 81.5c0-12.7-3.1-24.8-9.2-36.3l-3.4 2c5.7 10.8 8.6 22.2 8.6 34.3-.1 20.1-7.8 37.6-23.2 52.5l2.6 3c16.4-15.7 24.6-34.2 24.6-55.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M611.1 134.3l-4-9.2c-1 6.2-3.1 12.4-6.2 18.4 6.2-2.5 12.6-3.9 19-4.4l-8.8-4.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem43);
export default __webpack_public_path__ + "static/media/item43.bd75cd11829c2ce448b26ff2ffee5547.svg";
export { ForwardRef as ReactComponent };